/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserIdDto } from './UserIdDto';
import {
    UserIdDtoFromJSON,
    UserIdDtoFromJSONTyped,
    UserIdDtoToJSON,
} from './UserIdDto';

/**
 * 
 * @export
 * @interface UpdateUserInformationsDto
 */
export interface UpdateUserInformationsDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserInformationsDto
     */
    additionalProperties?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserInformationsDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserInformationsDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserInformationsDto
     */
    preferredEmail?: string;
    /**
     * 
     * @type {UserIdDto}
     * @memberof UpdateUserInformationsDto
     */
    userId: UserIdDto;
}

/**
 * Check if a given object implements the UpdateUserInformationsDto interface.
 */
export function instanceOfUpdateUserInformationsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function UpdateUserInformationsDtoFromJSON(json: any): UpdateUserInformationsDto {
    return UpdateUserInformationsDtoFromJSONTyped(json, false);
}

export function UpdateUserInformationsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserInformationsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'additionalProperties': !exists(json, 'additionalProperties') ? undefined : json['additionalProperties'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'preferredEmail': !exists(json, 'preferredEmail') ? undefined : json['preferredEmail'],
        'userId': UserIdDtoFromJSON(json['userId']),
    };
}

export function UpdateUserInformationsDtoToJSON(value?: UpdateUserInformationsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'additionalProperties': value.additionalProperties,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'preferredEmail': value.preferredEmail,
        'userId': UserIdDtoToJSON(value.userId),
    };
}

